var _a;
export var EValidateOptions;
(function (EValidateOptions) {
    EValidateOptions["MOBILE"] = "mobile";
    EValidateOptions["DATE_OF_BIRTH"] = "dob";
    EValidateOptions["EMAIL"] = "email";
})(EValidateOptions || (EValidateOptions = {}));
export var validateOptions = [
    {
        value: EValidateOptions.MOBILE,
        display: "Mobile No.",
    },
    {
        value: EValidateOptions.DATE_OF_BIRTH,
        display: "Date of Birth",
    },
    {
        value: EValidateOptions.EMAIL,
        display: "Email",
    },
];
export var validationOptionErrors = (_a = {},
    _a[EValidateOptions.MOBILE] = "Mobile number does not match Client records.",
    _a[EValidateOptions.DATE_OF_BIRTH] = "Invalid email address. Please enter a valid email.",
    _a[EValidateOptions.EMAIL] = "Invalid date of birth. Please enter a valid date.",
    _a);
export var EToastType;
(function (EToastType) {
    EToastType["SUCCESS"] = "success";
    EToastType["FAILURE"] = "failure";
})(EToastType || (EToastType = {}));
